<form [formGroup]="form" novalidate action="#">
  <div class="sidebar-search-row" style="margin-bottom: 10px">
    <tidy-search-input
      formControlName="search"
      [placeholder]="'Search'"
      [icon]="'assets/img/search-header.svg'"
      class="header-search" />
    <tidy-small-button
      [text]="buttonTitle"
      [image]="'assets/img/add-button-white.svg'"
      [primary]="true"
      (buttonClick)="addItem()" />
  </div>
</form>

<tidy-button
  class="secondary desktop-nav-button"
  [image]="'assets/icon/filter-white.png'"
  [action]="boundOpenDateRange"
  [text]="'Date'"
  [smallBody]="true" />

<!-- NOT DISPLAYED TRIGGRED BY BUTTON fn openDateRange -->
<div class="concierge-daterange-container">
  <tidy-daterange
    #daterangefilter
    id="daterangefilter"
    class="daterange-custom-input"
    [label]="'Date'"
    [icon]="'assets/svg/calendar.svg'"
    (customDateOption)="selectCustomDateRange($event)"
    (stringDateOption)="selectStringDateRange($event)"
    [(dateRangeForm)]="dateRangeForm"
    [selectOptions]="selectOptions"
    [rangeOption]="true"
    style="width: 10px;"
    [appearance]="'outline'" />
</div>

@if (chips?.length) {
  <div class="filter-chips-container">
    @for (chip of chips; track chip) {
      <ion-chip class="filter-chip">
        @if (chip.icon) {
          <mat-icon
            class="chip-icon"
            [style.color]="chip.color || 'inherit'">{{ chip.icon }}</mat-icon>
        }
        <ion-label>{{ chip.name | titlecase }}</ion-label>
        <ion-icon name="close-circle" (click)="removeChip(chip)" />
      </ion-chip>
    }
  </div>
}

<mat-menu #menu="matMenu" class="filter-menu">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
      <button mat-menu-item matTreeNodeToggle class="tree-node-padding">
        <mat-checkbox
          class="checkbox"
          [checked]="getNodeChecked(node)"
          (click)="$event.stopPropagation()"
          (change)="checkNode(node, $event)">
          {{ node.name | titlecase }}
        </mat-checkbox>
      </button>
    </mat-tree-node>
    <mat-tree-node
      *matTreeNodeDef="let node; when: hasChild"
      matTreeNodePadding>
      <button
        class="node-button-padding"
        mat-menu-item
        matTreeNodeToggle
        [attr.aria-label]="'Toggle ' + node.name">
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
        {{ node.name | titlecase }}
      </button>
    </mat-tree-node>
  </mat-tree>
  <mat-tree >
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
      <button mat-menu-item matTreeNodeToggle class="tree-node-padding">
        <mat-checkbox
          class="checkbox"
          [checked]="getNodeChecked(node)"
          (click)="$event.stopPropagation()"
          (change)="checkNode(node, $event)">
          {{ node.name | titlecase }}
        </mat-checkbox>
      </button>
    </mat-tree-node>
    <mat-tree-node
      *matTreeNodeDef="let node; when: hasChild"
      matTreeNodePadding>
      <button
        class="node-button-padding"
        mat-menu-item
        matTreeNodeToggle
        [attr.aria-label]="'Toggle ' + node.name">
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
        {{ node.name | titlecase }}
      </button>
    </mat-tree-node>
  </mat-tree>
</mat-menu>

